/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

import { Tools } from "../../utilities/Tools";

class Multiple {
  constructor(select, settings = {}) {
    this.select = select;
    this.settings = Object.assign(
      {
        multipleSelected: true, // Wyświetlanie listy z zaznaczonymi opcjami
        multipleSearch: true, // Wyświetlanie pola wyszukiwania
        multipleSearchMin: 5, // Minimalna ilość opcji dla wyświetlenia pola wyszukiwania
        multipleShowAllBtn: true, // Wyświetlanie przycisku "Zaznacz wszystkie"
        multipleShowSelectedBtn: true, // Wyświetlanie przycisk "Pokaż tylko zaznaczone"
        multipleShowDisabledOption: true, // Wyświetlanie nieaktywnych opcji
        multipleOptionValue: "- wybierz -", // Wyświetlanie domyślnej wartość dla .combobox__header w przypadku niewybrania żadnej z opcji
        multipleBodyPositionAbsolute: true, // .combobox__body pozycjonowanie absolutne (pojawienie się .combobox__body przesuwa lub nie przesuwa contentu poniżej selecta)
      },
      Tools.parseStringValuesInObjectLiteral(
        (({ dataset }) => {
          const datasetObject = Object.assign({}, dataset);

          delete datasetObject.toggle;
          return datasetObject;
        })(select)
      ),
      Tools.parseStringValuesInObjectLiteral(settings)
    );
    this._comboboxData = [];
    this._comboboxIsActive = false;
    this._comboboxSelectedOptions = "";
    this._filterString = {
      minLength: 3,
      value: "",
    };
    this._isComboboxToggleSelectedActive = false;

    // Stworzenie nowej funkcji z nowo przypisanym this na potrzeby dodawania i usuwania zadarzeń
    this.clickEventBind = this.clickEvent.bind(this);
    this.keyupEventBind = this.keyupEvent.bind(this);
    this.clickOutsideEventBind = this.clickOutsideEvent.bind(this);
    this.getSelectDataBind = this.getSelectData.bind(this);

    //
    this.init();
  }

  get comboboxData() {
    return this._comboboxData;
  }

  set comboboxData(value) {
    Object.assign(this._comboboxData, value);

    // Renderuje atrybutu title z nazwami zaznaczonych opcji.
    this.renderComboboxTitle();

    // Renderuje .combobox__header
    this.renderComboboxHeader();

    // Renderuje .combobox__selected
    this.renderComboboxSelected();

    // Renderuje .combobox__toggle-all
    this.renderComboboxToggle();

    // Renderuje .combobox__options
    this.renderComboboxOptions();
  }

  get comboboxIsActive() {
    return this._comboboxIsActive;
  }

  set comboboxIsActive(value) {
    this._comboboxIsActive = value;
  }

  get comboboxSelectedOptionsString() {
    return this._comboboxSelectedOptionsString;
  }

  set comboboxSelectedOptionsString(value) {
    this._comboboxSelectedOptionsString = value;
  }

  get filterString() {
    return this._filterString;
  }

  set filterString(obj) {
    if (this.filterString.value !== obj.value) {
      if (obj.value.length >= this.filterString.minLength) {
        Object.assign(this._filterString, obj);
      } else {
        Object.assign(this._filterString, { value: "" });
      }

      this.getSelectData();
    }
  }

  get isComboboxToggleSelectedActive() {
    return this._isComboboxToggleSelectedActive;
  }

  set isComboboxToggleSelectedActive(value) {
    this._isComboboxToggleSelectedActive = value;
    this.getSelectData();
  }

  // Dodanie combobox (stworzenie instancji) dla multiple select
  static create(select, settings = {}) {
    return new Multiple(select, settings);
  }

  events() {
    const _this = this;

    // Desktop + Mobile
    this.select.parentElement.addEventListener("click", this.clickEventBind, false);
    this.select.parentElement.addEventListener("keyup", this.keyupEventBind, false);

    //
    this.select.addEventListener("change", this.getSelectDataBind, false);
  }

  clickEvent(event) {
    event.stopPropagation();

    // Rozwijanie combobox'a
    if (event.target.classList.contains("form-select") || event.target.classList.contains("combobox__header")) {
      if (this.comboboxIsActive) {
        this.hide();
      } else {
        this.show();
      }
    }

    // Wybór opcji
    if (event.target.classList.contains("form-check-input")) {
      this.updateSelect(event.target);
    }

    // Przycisk zaznacz/odznacz wszystkie
    if (event.target.classList.contains("combobox__toggle-all")) {
      this.updateSelect();
    }

    // Przycisk pokaż zaznaczone
    if (event.target.classList.contains("combobox__toggle-selected")) {
      this.isComboboxToggleSelectedActive = !this.isComboboxToggleSelectedActive;
    }

    // Przycisk usuwania wybranej opcji z sekcji .combobox__selected
    if (event.target.classList.contains("btn-close")) {
      let btnClose = document.getElementById(event.target.dataset.optionId);

      btnClose.click();
    }
  }

  clickOutsideEvent(event) {
    this.hide();
  }

  keyupEvent(event) {
    this.filterString = {
      value: event.target.value,
    };
  }

  show() {
    // Przełączanie stanu combobox'a na true.
    this.comboboxIsActive = true;

    //
    if (!Boolean(window.iksoris.activeMultiple)) {
      window.iksoris.activeMultiple = this;
    } else {
      if (JSON.stringify(window.iksoris.activeMultiple) !== JSON.stringify(this)) {
        //
        window.iksoris.activeMultiple.hide();

        //
        window.iksoris.activeMultiple = this;
      }
    }

    // Pozycjonowanie .combobox, multipleBodyPositionAbsolute: true.
    let formSelect = this.select.parentElement;

    if (this.settings.multipleBodyPositionAbsolute) {
      formSelect.classList.add("combobox--absolute");

      if (this.isComboboxBodyVisibleInTheViewport()) {
        formSelect.classList.add("combobox--top");
      }

      // Pokazanie combobox'a.
      formSelect.classList.add("combobox--active");
    } else {
      // Pokazanie combobox'a.
      formSelect.classList.add("combobox--active");
    }

    // Dodanie zdarzenia nasłuchujacego kliknięcie.
    document.addEventListener("click", this.clickOutsideEventBind, false);

    // Dodanie zaznaczonych opcji (string) zaraz po pokazaniu combobox'a.
    this.comboboxSelectedOptionsString = this.convertComboboxSelectedOptionsToJSONString(this.select.selectedOptions);
  }

  hide() {
    // Przełączanie stanu combobox'a na false.
    this.comboboxIsActive = false;

    //
    window.iksoris.activeMultiple = null;

    // Pozycjonowanie .combobox, multipleBodyPositionAbsolute: true.
    if (this.settings.multipleBodyPositionAbsolute) {
      this.select.parentElement.classList.remove("combobox--absolute");
      this.select.parentElement.classList.remove("combobox--top");
    }

    // Ukrycie combobox'a.
    this.select.parentElement.classList.remove("combobox--active");

    // Usunięcie zdarzenia nasłuchujacego kliknięcie.
    document.removeEventListener("click", this.clickOutsideEventBind, false);

    // Wywołanie zdarzenia w przypadku zmian opcji.
    if (
      this.convertComboboxSelectedOptionsToJSONString(this.select.selectedOptions) !==
      this.comboboxSelectedOptionsString
    ) {
      this.select.dispatchEvent(
        new CustomEvent("iksorismultiplechange", {
          bubbles: true,
          detail: {
            form: this.select.form,
            select: this.select,
          },
        })
      );
    }
  }

  showDefaultSelect() {
    this.select.classList.remove("d-none");
  }

  hideDefaultSelect() {
    this.select.classList.add("d-none");
  }

  // Pobranie danych z selecta
  getSelectData() {
    const _this = this;

    // Zapisanie danych dla combobox'a
    this.comboboxData = (function ({ children }) {
      let data = [];

      if (children.length > 0) {
        [].slice.call(children).forEach(function (element, index) {
          switch (element.localName) {
            case "option":
              data.push({
                visible: _this.isOptionMatched(element.label, element.selected), // Widoczność podczas filtrowania
                original: element, // Node
                localName: element.localName, // Nazwa tagu
                id: `${element.parentElement.id}-${index}`,
                label: element.label, // Etykieta
                value: element.value, // Wartość option
                disabled: element.disabled, // Atrybut disabled
                selected: element.selected, // Atrybut selected
              });
              break;
            case "optgroup":
              data.push({
                localName: element.localName, // Nazwa tagu grupy
                id: `${element.parentElement.id}-${index}`,
                label: element.label, // Etykieta grupy
                selected: _this.isAllOptionsAreCheckedInTheGroup(element.children),
                options: (function (children) {
                  let data = [];

                  [].slice.call(children).forEach(function (element, index) {
                    data.push({
                      visible: _this.isOptionMatched(element.label, element.selected), // Widoczność podczas filtrowania
                      original: element, // Node
                      localName: element.localName, // Nazwa tagu
                      label: element.label, // Etykieta
                      value: element.value, // Wartość option
                      disabled: element.disabled, // Atrybut disabled
                      selected: element.selected, // Atrybut selected
                    });
                  });

                  return data;
                })(element.children),
              });
              break;
          }
        });
      }

      return data;
    })(this.select);
  }

  // Sprawdzanie czy .combobox__body jest w całości widoczne.
  isComboboxBodyVisibleInTheViewport() {
    let formSelect = this.select.parentElement;
    let formSelectBoundingClientRectBottom = formSelect.getBoundingClientRect().bottom;
    let comboboxBodyOuterHeight = jQuery(formSelect.querySelector(".combobox__body")).outerHeight();

    return window.innerHeight - formSelectBoundingClientRectBottom < comboboxBodyOuterHeight;
  }

  // Sprawdzamy czy nazwa etykiety jest dopasowana do filtra
  isOptionMatched(label, selected) {
    let string = Tools.escapeRegExpSpecialCharacters(this.filterString.value);

    return (
      (this.filterString.value !== "" ? new RegExp(string, "gi").test(label) : true) &&
      (this.isComboboxToggleSelectedActive ? selected : true)
    );
  }

  // Podkreślenie etykiety przy filtrowaniu
  markLabelOfMatchedOption(label) {
    let string = Tools.escapeRegExpSpecialCharacters(this.filterString.value);
    let regExp = new RegExp(string, "gi");

    return Boolean(regExp.exec(label))
      ? label.replaceAll(regExp, `<mark class="p-0 bg-warning">${label.match(regExp)[0]}</mark>`)
      : label;
  }

  // Sprawdzamy czy jakakolwiek opcja jest zaznaczona
  isAnyOptionIsChecked() {
    return this.select.selectedOptions.length > 0;
  }

  // Sprawdzamy czy wszystkie opcje są zaznaczone z pominięciem opcji wyłączonych (disabled)
  isAllOptionsAreChecked() {
    let options = this.select.options;
    let optionsLength = options.length;
    let selectedOptionsLength = 0;
    let disabledOptionsLength = 0;

    [].slice.call(options).forEach(function (option) {
      if (option.selected) {
        selectedOptionsLength++;
      }

      if (option.disabled) {
        disabledOptionsLength++;
      }
    });

    return optionsLength - disabledOptionsLength === selectedOptionsLength;
  }

  // Sprawdzamy czy wszystkie opcje są zaznaczone w grupie z pominięciem opcji wyłączonych (disabled)
  isAllOptionsAreCheckedInTheGroup(options) {
    let optionsLength = options.length;
    let selectedOptionsLength = 0;
    let disabledOptionsLength = 0;

    [].slice.call(options).forEach(function (option) {
      if (option.selected) {
        selectedOptionsLength++;
      }

      if (option.disabled) {
        disabledOptionsLength++;
      }
    });

    return optionsLength - disabledOptionsLength === selectedOptionsLength;
  }

  // Zapisanie
  convertComboboxSelectedOptionsToJSONString(selectedOptions) {
    return JSON.stringify(
      [...selectedOptions].map(function (option, index, array) {
        return option.value;
      })
    );
  }

  renderCombobox() {
    const _this = this;
    let combobox = this.select.nextElementSibling;

    if (combobox && combobox.classList.contains("combobox")) {
      combobox.remove();
    }

    this.select.insertAdjacentHTML(
      "afterend",
      (function (select) {
        return `
                <div class="combobox">
                    <div class="combobox__header"></div>
                    <div class="combobox__body">
                        <div class="combobox__selected mb-2"></div>
                    
                        ${(function () {
                          // Generowanie pola filtrowania
                          if (
                            _this.settings.multipleSearch &&
                            select.options.length >= _this.settings.multipleSearchMin
                          ) {
                            return `<div class="combobox__search mb-2">
                                            <input class="form-control" type="search" placeholder="Filtruj listę" aria-label="Filtruj listę" value="${_this.filterString.value}">
                                        </div>`;
                          } else {
                            return ``;
                          }
                        })()}
                    
                        <div class="combobox__toggle"></div>
                        <div class="combobox__options"></div>
                    </div>
                </div>`;
      })(this.select)
    );
  }

  // Generowanie atrybutu title z nazwami zaznaczonych opcji.
  renderComboboxTitle() {
    this.select.parentElement.setAttribute(
      "title",
      [].slice
        .call(this.select.selectedOptions)
        .map(function (option, index) {
          return option.text;
        })
        .join(", ")
    );
  }

  // Generowanie informacji o zaznaczonych opcjach
  renderComboboxHeader() {
    const _this = this;
    let comboboxHeader = this.select.nextElementSibling.querySelector(".combobox__header");

    comboboxHeader.innerHTML = (function (select) {
      return `${(function (selectedOptions) {
        if (selectedOptions.length > 0) {
          if (_this.isAllOptionsAreChecked()) {
            return `Wybrano: wszystkie`;
          } else {
            return `Wybrano: ${selectedOptions.length}`;
          }
        } else {
          return _this.settings.multipleOptionValue !== "" ? _this.settings.multipleOptionValue : "&nbsp;";
        }
      })(select.selectedOptions)}`;
    })(this.select);
  }

  // Generowanie zaznaczonych opcji
  renderComboboxSelected() {
    if (this.settings.multipleSelected) {
      const _this = this;
      let comboboxSelected = this.select.nextElementSibling.querySelector(".combobox__selected");

      if (this.isAllOptionsAreChecked()) {
        comboboxSelected.innerHTML = `<div class="alert alert-warning alert-dismissible border d-inline-flex align-items-center mb-1 me-1 ps-2 py-0 pe-4" role="alert">Wszystkie<button aria-label="Usuń" class="btn-close p-1" type="button" data-option-id="${
          _this.select.id + "-all"
        }"></button></div>`;
      } else {
        comboboxSelected.innerHTML = (function (data) {
          return data
            .map(function (element, elementIndex) {
              if (element.localName === "option") {
                if (element.selected) {
                  return `<div class="alert alert-warning alert-dismissible border d-inline-flex align-items-center mb-1 me-1 ps-2 py-0 pe-4" role="alert">${
                    element.label
                  }<button aria-label="Usuń" class="btn-close p-1" type="button" data-option-id="${
                    _this.select.id + "-" + elementIndex
                  }"></button></div>`;
                } else {
                  return ``;
                }
              } else if (element.localName === "optgroup") {
                return element.options
                  .map(function (option, optionIndex) {
                    if (option.selected) {
                      return `<div class="alert alert-warning alert-dismissible border d-inline-flex align-items-center mb-1 me-1 ps-2 py-0 pe-4" role="alert">${
                        option.label
                      }<button aria-label="Usuń" class="btn-close p-1" type="button" data-option-id="${
                        _this.select.id + "-" + elementIndex + "" + optionIndex
                      }"></button></div>`;
                    } else {
                      return ``;
                    }
                  })
                  .join("");
              }
            })
            .join("");
        })(this.comboboxData);
      }
    }
  }

  // Generowanie przycisków
  renderComboboxToggle() {
    const _this = this;

    let comboboxToggleGroup = this.select.nextElementSibling.querySelector(".combobox__toggle");

    comboboxToggleGroup.innerHTML = (function () {
      return `<div class="combobox__toggle-group mb-2" role="group" aria-label="Przyciski">
                ${(function () {
                  let html = "";

                  if (_this.settings.multipleShowAllBtn) {
                    html += `<button id="${
                      _this.select.id + "-all"
                    }" type="button" class="btn btn-light combobox__toggle-all ${
                      _this.isAllOptionsAreChecked() ? "border" : ""
                    }">${_this.isAllOptionsAreChecked() ? "Odznacz wszystkie" : "Zaznacz wszystkie"}</button>`;
                  }

                  if (_this.settings.multipleShowSelectedBtn) {
                    html += `<button id="${
                      _this.select.id + "-selected"
                    }" type="button" class="btn btn-light combobox__toggle-selected ${
                      _this.isComboboxToggleSelectedActive ? "border" : ""
                    }">${_this.isComboboxToggleSelectedActive ? "Pokaż wszystkie" : "Pokaż tylko zaznaczone"}</button>`;
                  }

                  return html;
                })()}
              </div>`;
    })();
  }

  // Generowanie listy opcji
  renderComboboxOptions() {
    const _this = this;
    let comboboxOptions = this.select.nextElementSibling.querySelector(".combobox__options");

    comboboxOptions.innerHTML = (function (data) {
      return [].slice
        .call(data)
        .map(function (element, elementIndex) {
          if (element.localName === "option") {
            let showDisabledOption = element.disabled && !_this.settings.multipleShowDisabledOption;
            let selected = element.selected ? "checked" : "";
            let disabled = element.disabled ? "disabled" : "";

            return `<div class="form-check ${element.visible && !showDisabledOption ? "" : "d-none"}">
                                    <input class="form-check-input" id="${element.id}" type="checkbox" value="${
              element.value
            }" data-option-index="${elementIndex}" ${selected} ${disabled}>
                                    <label class="form-check-label" for="${
                                      element.id
                                    }">${_this.markLabelOfMatchedOption(element.label)}</label>
                                </div>`;
          } else if (element.localName === "optgroup") {
            let selected = element.selected ? "checked" : "";
            let html = `<div class="form-check border-bottom mt-2 pt-1 pb-1">
                                        <input class="form-check-input" id="${element.id}" type="checkbox" data-group-index="${elementIndex}" ${selected}>
                                        <label class="form-check-label fw-bold text-uppercase" for="${element.id}">${element.label}</label>
                                    </div>`;

            html += [].slice
              .call(element.options)
              .map(function (option, optionIndex) {
                let showDisabledOption = option.disabled && !_this.settings.multipleShowDisabledOption;
                let selected = option.selected ? "checked" : "";
                let disabled = option.disabled ? "disabled" : "";

                return `<div class="form-check ${option.visible && !showDisabledOption ? "" : "d-none"}">
                                            <input class="form-check-input" id="${
                                              element.id + "" + optionIndex
                                            }" type="checkbox" value="${option.value}" data-group-index="${elementIndex}" data-option-index="${optionIndex}" ${selected} ${disabled}>
                                            <label class="form-check-label" for="${
                                              element.id + "" + optionIndex
                                            }">${_this.markLabelOfMatchedOption(option.label)}</label>
                                        </div>`;
              })
              .join("");

            return html;
          }
        })
        .join("");
    })(this.comboboxData);
  }

  updateSelect(selectedOption = null) {
    const _this = this;

    if (selectedOption) {
      let optionIndex = selectedOption.dataset.optionIndex;
      let groupIndex = selectedOption.dataset.groupIndex;

      if (Boolean(optionIndex) && !Boolean(groupIndex)) {
        // Zaznaczamy opcję w select multiple
        this.comboboxData[optionIndex].original.selected = !this.comboboxData[optionIndex].original.selected;
      } else if (!Boolean(optionIndex) && Boolean(groupIndex)) {
        // Zaznaczmy grupę w select multiple
        [].slice.call(this.comboboxData[groupIndex].options).forEach(function (element) {
          if (!element.disabled) {
            element.original.selected = !_this.comboboxData[groupIndex].selected;
          }
        });
      } else if (Boolean(optionIndex) && Boolean(groupIndex)) {
        // Zaznaczmy opcję w grupie select multiple
        this.comboboxData[groupIndex].options[optionIndex].original.selected = !this.comboboxData[groupIndex].options[
          optionIndex
        ].original.selected;
      }
    } else {
      // Zaznaczmy/odznaczamy wszystkie opcje
      if (this.isAllOptionsAreChecked()) {
        [].slice.call(this.select.options).forEach(function (element) {
          if (!element.disabled) {
            element.selected = false;
          }
        });
      } else {
        [].slice.call(this.select.options).forEach(function (element) {
          if (!element.disabled) {
            element.selected = true;
          }
        });
      }
    }

    // Wywołanie zdarzenia change w przypadku zmian opcji.
    this.select.dispatchEvent(new CustomEvent("change", { bubbles: true }));
  }

  // Programowe zaznaczanie opcji

  // Usunięcie combobox dla multiple select
  destroy() {
    this.showDefaultSelect();
    this.select.nextElementSibling.remove();
    this.select.parentElement.classList.remove("combobox--active");
    this.select.parentElement.removeEventListener("click", this.clickEventBind, false);
    this.select.parentElement.removeEventListener("keyup", this.keyupEventBind, false);
    this.select.removeEventListener("change", this.getSelectDataBind, false);
  }

  val(...params) {
    if (params.length === 0) {
      let array = [];
      [].slice.call(this.select.options).forEach(function (element) {
        if (element.selected) {
          array.push(element.value);
        }
      });

      return array;
    } else if (params.length > 0 && Array.isArray(params[0])) {
      let options = params[0];

      if (options.length === 0) {
        [].slice.call(this.select.options).forEach(function (element) {
          element.selected = false;
        });
      } else if (options.length > 0) {
        [].slice.call(this.select.options).forEach(function (element) {
          element.selected = options.includes(parseInt(element.value));
        });
      }
    }

    // Wywołanie zdarzenia change w przypadku zmian opcji.
    this.select.dispatchEvent(new CustomEvent("change", { bubbles: true }));
  }

  init() {
    // Jeżeli select multiple jest disabled nie renderujemy combobox'a i zostawiamy nieaktywny select.
    if (this.select.disabled) {
      this.select.size = 1;
      this.select.parentElement.classList.remove("form-select");
      return false;
    }

    // Ukrycie domyślnego, przeglądarkowego selecta z multiple, jeżeli ma być zastosowany combobox.
    this.hideDefaultSelect();

    // Zdarzenia
    this.events();

    // Renderowanie .combobox
    this.renderCombobox();

    // Pobranie danych (optgroup, option) z domyślnego, przeglądarkowego selecta.
    this.getSelectData();

    // Utworzenie Map
    iksoris.instances = iksoris.instances || new Map();

    if (!Boolean(iksoris.instances.get(this.select.id))) {
      iksoris.instances.set(this.select.id, this);
    }
  }
}

export { Multiple };
